import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import classNames from "classnames";
import _ from "lodash";

import DateFilterSelect from "./DateFilterSelect";
import Filters from "./Filters";
import HistoryList from "./HistoryList";
import Provider from "./Provider";
import SearchFilters from "./SearchFilters";
import SortSelection from "./SortSelection";
import Tabs from "./Tabs";
import TodoWarning from "./TodoWarning";

// SASS Imports
require("./History.scss");

export default class History extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFiltersOpen: false,
    };

    this.containerRef = React.createRef();
    this.panelRef = React.createRef();
  }

  render() {
    const { isOpen } = this.props;

    return (
      <Provider>
        <aside ref={this.containerRef} className={classNames({ "open": isOpen, "hidden": !isOpen })}>
          <div ref={this.panelRef} className="container-fluid historyPanel">
            <Tabs />
            <div className="row historyFilters">
              <div className="col-sm-8 col-xs-7 no-right-padding historyView">
                <DateFilterSelect />
              </div>
              <div className="col-sm-4 col-xs-5 no-left-padding text-right historySort">
                <SortSelection />
              </div>
            </div>

            <hr />
            <SearchFilters />
            <TodoWarning />
            <HistoryList
              containerRef={this.containerRef}
              panelRef={this.panelRef}
            />
          </div>
          <Filters />
        </aside>
      </Provider>
    );
  }
}

History.displayName = "History";

History.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

History.defaultProps = {
  isOpen: false,
};



// WEBPACK FOOTER //
// ./app/components/History/History.jsx